import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=26bd5501&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bd5501')) {
      api.createRecord('26bd5501', component.options)
    } else {
      api.reload('26bd5501', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=26bd5501&", function () {
      api.rerender('26bd5501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/Calendar.vue"
export default component.exports